define([
  'jquery',
  'knockout'],
  function ($, ko) {
    'use strict';

    function priceTemplate(prefix, price, cents, shouldShowCents, template) {
      let prefixText = prefix !== '' ? `${prefix}-` : '';
      let ret;
      switch (template) {
        case 'thd':
          ret = `
          <span class="f4 v-top dib">$</span>
          <span class="f3 lh-solid">${price}</span>
          ${
            shouldShowCents
              ? `<span class="f6 v-top mt1 dib">${cents}</span>`
              : ``
            }`;
          break
        case 'plain':
          ret = `$${price}${shouldShowCents ? `.${cents}` : ``}`
          break;
        default:
          ret = `<span class="${prefixText}currency">$</span><span class="${prefixText}price">${price}</span>${
            shouldShowCents
              ? `<span class="${prefixText}cents">.${cents}</span>`
              : ``
            }`;
          break;
      }
      return ret;
    }

    ko.bindingHandlers.formatMoney = {
      update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var formatMoneyPrefix = allBindingsAccessor().formatMoneyPrefix || '';
        var shouldShowCents = allBindingsAccessor().shouldShowCents === false ? false : true;
        const templateType = allBindingsAccessor().templateType;
        var formattedValue = ko.utils.unwrapObservable(valueAccessor());
        var formatMoneyNATitle = allBindingsAccessor().formatMoneyNATitle || '';
        ko.bindingHandlers.html.update(element, function () {
          if (formattedValue !== undefined) {
            var regexForThousands = /\B(?=(\d{3})+(?!\d))/g;
            var isValidNumber = !isNaN(formattedValue) && formattedValue !== '';
            var context = bindingContext.$data.isLoadingPrices ?
              bindingContext.$data :
              (bindingContext.$parent && bindingContext.$parent.isLoadingPrices) ?
                bindingContext.$parent :
                undefined;
            var isLoading = context ? context.isLoadingPrices() : false;
            if (isValidNumber || isLoading) {
              // Prevents flashing "N/A" while loading price
              if (isLoading) {
                if ($(element).attr('data-current-price') === undefined || $(element).attr('data-current-price') === 'N/A') {
                  $(element).attr('data-current-price', '0.00');
                }
                formattedValue = parseFloat($(element).attr("data-current-price"));
              }
              if (typeof formattedValue === 'string') {
                formattedValue = parseFloat(formattedValue);
              }
              formattedValue = formattedValue.toFixed(2).toString().replace(regexForThousands, ',');
              var priceCents = formattedValue.split(".");
              return priceTemplate(formatMoneyPrefix, priceCents[0], priceCents[1], shouldShowCents, templateType);
            } else if (formattedValue === "") {
              return priceTemplate(formatMoneyPrefix, 0, "", shouldShowCents, templateType);
            } else {
              return `<span title="${formatMoneyNATitle}" class="${(formatMoneyPrefix !== '' ? `${formatMoneyPrefix}-` : '')}na">${formattedValue}</span>`;
            }
          }
        });
      }
    };
  });
